import {View, StyleSheet, StyleProp, TextStyle} from 'react-native';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import Styles from 'src/components/Styles';

export type DialogueButtonsProps = {
  button1Title: string;
  button2Title?: string;
  button1Action?: () => void;
  button2Action?: () => void;
  button1TextStyle?: StyleProp<TextStyle>;
  button2TextStyle?: StyleProp<TextStyle>;
  button1Hide?: boolean;
  button2Hide?: boolean;
};

const DialogueButtons = (props: DialogueButtonsProps) => {
  return (
    <View style={styles.buttonsContaner}>
      {!props.button1Hide && (
        <RoundedAppButton
          buttonType={RoundedAppButtonType.Solid}
          buttonContainerStyle={[styles.buttonStyle]}
          onPress={props.button1Action}
          accessibilityLabelValue={props.button1Title}
          titleText={props.button1Title}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
          textStyle={[
            styles.buttonText,
            getSnackDescriber()?.snackDetailsBtnFontSTyle(),
            props.button1TextStyle,
          ]}
          testID="qa_Checkout.ModalVerify_btn"
        />
      )}
      {!props.button2Hide && (
        <RoundedAppButton
          buttonType={RoundedAppButtonType.Outline}
          buttonContainerStyle={[styles.buttonStyle]}
          onPress={props.button2Action}
          accessibilityLabelValue={props.button2Title}
          titleText={props.button2Title}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
          textStyle={[
            getSnackDescriber()?.snackDetailsBtnFontSTyle(),
            styles.buttonText,
            props.button2TextStyle,
          ]}
          testID="qa_Checkout.ModalCancel_btn"
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  buttonsContaner: {
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: Styles.Spacing.m2,
  },
  buttonStyle: {
    marginVertical: Styles.Spacing.m2,
    alignSelf: 'center',
  },
  buttonText: {
    color: Styles.white,
    fontSize: Styles.Fonts.f1,
    fontWeight: '700',
    textAlign: 'center',
    width: 250,
  },
});
export default DialogueButtons;
